module.exports = __webpack_public_path__ + "static/media/CheckIn.725e8282.svg";